import React from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import HniAdminDashboard from "./HniAdminDashboard";
import HniRejectionDashboard from "./HniRejectionDashboard";
import HniDeleteDashboard from "./HniDeleteDashboard";
function HniDashboardTabs(props) {
  return (
    <div>
      <Header title={props.title} portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="tab-content" id="mainTabContent">
          <div
            className="tab-pane fade show active"
            id="team"
            role="tabpanel"
            aria-labelledby="team-tab"
          >
            <div className="secondary-tabs">
              <div className="card-tab-list">
                <ul className="nav page-tabs" id="mainTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="admin-tab"
                      data-toggle="tab"
                      data-target="#admin"
                      type="button"
                      role="tab"
                      aria-controls="admin"
                      aria-selected="true"
                    >
                      Admin Dashboard
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="rejection-tab"
                      data-toggle="tab"
                      data-target="#rejection"
                      type="button"
                      role="tab"
                      aria-controls="rejection"
                      aria-selected="false"
                    >
                      Rejection Dashboard
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="deletedash-tab"
                      data-toggle="tab"
                      data-target="#deletedash"
                      type="button"
                      role="tab"
                      aria-controls="deletedash-tab"
                      aria-selected="false"
                    >
                      Delete Application
                    </button>
                  </li>
                </ul>
              </div>
              <div className="card-tab-details">
                <div
                  className="tab-content dashboard-tab-content"
                  id="nav-tabContent"
                >
                  <div
                    className="tab-pane fade show active"
                    id="admin"
                    role="tabpanel"
                    aria-labelledby="nav-admin-tab"
                  >
                    <HniAdminDashboard />
                  </div>
                  <div
                    className="tab-pane fade show "
                    id="rejection"
                    role="tabpanel"
                    aria-labelledby="nav-rejection-tab"
                  >
                    <HniRejectionDashboard />
                  </div>
                  <div
                    className="tab-pane fade show "
                    id="deletedash"
                    role="tabpanel"
                    aria-labelledby="nav-deletedash-tab"
                  >
                    <HniDeleteDashboard />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default HniDashboardTabs;
